(() => {
  const root = window.Shopify?.routes?.root || '/';
  function setup(container = document) {
    container.querySelectorAll('[data-ml-product]').forEach(section => {
      if (section.dataset.mlReady) return;
      section.dataset.mlReady = 'true';
      const form = section.querySelector('form');
      const select = section.querySelector('[data-ml-variant]');
      const pickers = Array.from(section.querySelectorAll('.ml-option-picker'));
      const button = section.querySelector('[data-ml-add]');
      const status = section.querySelector('[data-ml-status]');
      const image = section.querySelector('.ml-main-image');
      const sticky = section.querySelector('[data-ml-sticky]');
      const stickyButton = section.querySelector('[data-ml-sticky-add]');
      let busy = false;
      const individualWrap = section.querySelector('[data-ml-bundle-individuals]');
      const individualRows = Array.from(section.querySelectorAll('[data-ml-bundle-item]'));
      const normalized = value => String(value ?? '').trim().toLowerCase();
      function variantFor(pickersToMatch) {
        return Array.from(select.options).find(option => pickersToMatch.every(picker => normalized(option.getAttribute('data-option-' + picker.dataset.optionPosition)) === normalized(picker.value)));
      }
      function bundleSelections() {
        const quantity = Number(form.querySelector('input[name="quantity"]:checked')?.value || 1);
        if (quantity === 1) return [select.selectedOptions[0]];
        return individualRows.slice(0, quantity).map(row => variantFor(Array.from(row.querySelectorAll('.ml-bundle-option'))));
      }
      function updateBundleUI() {
        const quantity = Number(form.querySelector('input[name="quantity"]:checked')?.value || 1);
        if (individualWrap) individualWrap.hidden = quantity === 1;
        individualRows.forEach((row, index) => { row.hidden = quantity === 1 || index >= quantity; });
        const variants = bundleSelections();
        const valid = variants.every(v => v && v.dataset.available === 'true');
        if (quantity > 1 && status) status.textContent = valid ? '' : 'Please choose an available size and color for every item.';
        return valid;
      }
      individualRows.forEach(row => row.querySelectorAll('.ml-bundle-option').forEach(picker => picker.addEventListener('change', update)));

      // Each visible Size/Color choice maps to an actual Shopify variant ID.
      // Use the data rendered in the hidden Shopify variant selector as the source of truth.
      function syncPickers() {
        const current = select?.selectedOptions?.[0];
        if (!current) return;
        pickers.forEach(picker => {
          const key = 'option' + picker.dataset.optionPosition;
          const value = current.dataset[key];
          if (value !== undefined && value !== '') picker.value = value;
        });
      }
      function chooseVariant() {
        if (!select || !pickers.length) return;
        const normalized = value => String(value ?? '').trim().toLowerCase();
        const values = pickers.map(p => normalized(p.value));
        const match = Array.from(select.options).find(option =>
          pickers.every(picker => normalized(option.getAttribute('data-option-' + picker.dataset.optionPosition)) === normalized(picker.value))
        ) || Array.from(select.options).find(option => {
          const parts = option.textContent.split('—')[0].split('/').map(normalized);
          return values.length === parts.length && values.every((v, i) => v === parts[i]);
        });
        if (!match) {
          if (status) status.textContent = 'Please select a size and color.';
          return;
        }
        if (status) status.textContent = '';
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      pickers.forEach(picker => picker.addEventListener('change', chooseVariant));
      syncPickers();
      function switchImage(src) {
        if (!src || !image) return;
        image.removeAttribute('srcset');
        image.src = src;
        section.querySelectorAll('[data-ml-image]').forEach(thumb => {
          const selected = thumb.dataset.mlImage === src;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });
      }
      section.querySelectorAll('[data-ml-image]').forEach(thumb => thumb.addEventListener('click', () => switchImage(thumb.dataset.mlImage)));
      function update() {
        const option = select?.selectedOptions[0];
        if (!option) return;
        const variantId = Number(option.value);
        const validVariant = Number.isSafeInteger(variantId) && variantId > 0;
        const available = validVariant && option.dataset.available === 'true';
        const quantities = [...form.querySelectorAll('input[name="quantity"]')];
        const quantity = Number(quantities.find(radio => radio.checked)?.value || 1);
        quantities.forEach(radio => radio.closest('.ml-bundle')?.classList.toggle('is-selected', radio.checked));
        section.querySelector('[data-ml-price-one]').textContent = option.dataset.price;
        section.querySelector('[data-ml-price-two]').textContent = option.dataset.priceDouble;
        section.querySelector('[data-ml-price-three]').textContent = option.dataset.priceTriple;
        [['[data-ml-compare-one]', option.dataset.compare], ['[data-ml-compare-two]', option.dataset.compareDouble], ['[data-ml-compare-three]', option.dataset.compareTriple]].forEach(([selector, text]) => {
          const node = section.querySelector(selector);
          node.textContent = text || '';
          node.hidden = !text;
        });
        const correctProduct = section.dataset.mlCorrectProduct === 'true';
        button.disabled = !available || !updateBundleUI() || busy || !correctProduct;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.textContent;
        section.querySelector('[data-ml-sticky-price]').textContent = quantity === 3 ? option.dataset.priceTriple : quantity === 2 ? option.dataset.priceDouble : option.dataset.price;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
      select?.addEventListener('change', () => {
        syncPickers();
        update();
        switchImage(select.selectedOptions[0]?.dataset.image);
      });
      form?.querySelectorAll('input[name="quantity"]').forEach(radio => radio.addEventListener('change', () => {
        if (individualRows.length) individualRows.forEach(row => row.querySelectorAll('.ml-bundle-option').forEach(picker => {
          const source = pickers.find(p => p.dataset.optionPosition === picker.dataset.optionPosition);
          if (!row.dataset.mlTouched && source) picker.value = source.value;
        }));
        update();
      }));
      individualRows.forEach(row => row.querySelectorAll('.ml-bundle-option').forEach(picker => picker.addEventListener('change', () => { row.dataset.mlTouched = 'true'; })));

      stickyButton?.addEventListener('click', () => {
        if (!button.disabled) form.requestSubmit(button);
      });
      if ('IntersectionObserver' in window && button && sticky) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        observer.observe(button);
      }
      form?.addEventListener('submit', async event => {
        if (!window.fetch) return;
        event.preventDefault();
        if (busy || button.disabled) return;
        busy = true;
        button.disabled = true;
        stickyButton.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        const selectedVariants = bundleSelections();
        if (selectedVariants.some(v => !v || v.dataset.available !== 'true')) { status.textContent = 'Please select an available variant for every item.'; busy = false; update(); return; }
        const grouped = new Map();
        selectedVariants.forEach(v => grouped.set(Number(v.value), (grouped.get(Number(v.value)) || 0) + 1));
        const cartItems = Array.from(grouped, ([id, quantity]) => ({ id, quantity }));
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: cartItems, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || response.statusText);
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && result.sections?.['cart-drawer']) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
              drawer.open?.();
              const cartResponse = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                document.querySelectorAll('[data-ml-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = !cart.item_count; });
              }
            } catch {
              location.assign(root + 'cart');
            }
          } else {
            location.assign(root + 'cart');
          }
        } catch (error) {
          status.textContent = error.message;
        } finally {
          busy = false;
          button.removeAttribute('aria-busy');
          update();
        }
      });
      update();
    });
    container.querySelectorAll('[data-ml-comparison]').forEach(comparison => {
      if (comparison.dataset.mlReady) return;
      comparison.dataset.mlReady = 'true';
      comparison.querySelector('input').addEventListener('input', event => comparison.style.setProperty('--ml-split', event.target.value + '%'));
    });
    container.querySelectorAll('[data-ml-cookies]').forEach(button => {
      button.hidden = !window.Shopify?.customerPrivacy?.showPreferences;
      if (!button.hidden && !button.dataset.mlReady) {
        button.dataset.mlReady = 'true';
        button.addEventListener('click', () => window.Shopify.customerPrivacy.showPreferences());
      }
    });
  }
  document.addEventListener('DOMContentLoaded', () => setup());
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
